import { render } from "./BtnAnswerSkip.vue?vue&type=template&id=45f87a60&scoped=true"
import script from "./BtnAnswerSkip.vue?vue&type=script&lang=js"
export * from "./BtnAnswerSkip.vue?vue&type=script&lang=js"

import "@/css/components/btn-answer-skip.css?vue&type=style&index=0&id=45f87a60&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f87a60"]])

export default __exports__